export const LeftHeaderWithButton = {
    paddingTop: '10px'
};
export const RightHeaderWithButton = {
    marginTop: '5px',
    paddingTop: '5px',
    paddingBottom: '6px'
};
export const FiltersOnStyle = {
    top: '2px',
    paddingTop: '5px',
    paddingBottom: '6px'
};
export const NewNotificationStyle = {
    top: '2px',
    paddingTop: '10px',
    paddingBottom: '10px'
};
export const IconHeader = {
    fontSize: '9px'
};
export const HeaderCursor = {
    cursor: 'pointer'
};

export const RightResultsPerPageDropdown = {
    float: 'right'
};



// WEBPACK FOOTER //
// ./src/views/Assets/util/css.js